import React, {useEffect} from 'react';
import {useScores} from '../hooks/useScore';
import {useNavigate, useParams} from "react-router";
import Modal from "./Modal";
import FormScore from "./FormScore";
import {useModal} from "../Contexts/Modal";
import ChartTest from "./ChartTest";
import {ScoreItem} from "./ScoreItem";
import {TypeForm} from "../types";
import "../styles/tableScores.scss"
import "../styles/ScoreList.scss"
import {CategoryDetail} from "./CategoryDetail";
import {useCategory} from "../hooks/useCategory";
import {AgGrid} from "./AgGrid";


export const ScoreList: React.FC = () => {
    const category = useParams().category ?? "";
    const { category : categoryEntity,  isLoading: isCategoryLoading } = useCategory(category || "");
    const navigate = useNavigate();
    const {scores, isLoading: isScoresLoading} = useScores(category || "");
    const {openModal} = useModal();

    useEffect(() => {
        if  (!isCategoryLoading && !isScoresLoading && categoryEntity == null) {
            navigate("/")
        }
    }, [isCategoryLoading, isScoresLoading, categoryEntity]);

    if (isScoresLoading && isCategoryLoading || categoryEntity == null) {
        return <div>Chargement…</div>;
    }
    return (
        <div id={"scoreList"}>
            { category && <CategoryDetail category={categoryEntity}/>}
            <button className={"newScore"} onClick={() => openModal(<FormScore typeForm={TypeForm.create} category={category}/>)}>Ajouter un score</button>
            {
                scores && scores.at(-1) ?
                    <>
                        <ChartTest/>
                        <AgGrid scores={scores} category={category}/>
                    </>
                    :
                    <div>Aucune données</div>
            }
        </div>
    )
        ;
};

